import requestManager from "@comp/platformApi/requestManager";
import appHelper from "@util/appHelper";

export default {

    /**
     * params:
     * bizId
     * browsingBizType
     * startTime
     * endTime
     */
    recordAdd : {
        url: 'portal/v4/browsing/add',
        method : 'post',
    },

    /**
     * @param   {Object}    options     keys: browsingBizId, browsingBizType, startTime, endTime
     * @param   {Function}  callback
     */
    addBrowsing(options, callback) {
        requestManager.request({
            url: 'portal/v4/browsing/add',
            method : 'post',
            data : options
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result);
        });
    },

    transmitBrow : {
        url: 'base/wx/jssdkconfig/transmitBrow',
        method : 'post',
        // params : {
        //     id: getUrlParam('id'),
        //     bizType: 'VOD',
        //     promotionCode: code
        // }
    }

};
